const DEMO_DOMAINS = [
  "demo.chargeback.io",
  "demo.dev.chargeback.io",
  "demo.staging.chargeback.io"
  // 'localhost' //for local testing
]

// Pure counterpart of the `useExternalDemoMode` hook, so selectors and other non-component code
// can ask the same question without a React context.
export const isExternalDemoMode = (auth) => {
  const isDemoDomain = DEMO_DOMAINS.includes(window?.location?.hostname)

  if (!auth?.accessToken) return isDemoDomain

  return isDemoDomain && !!auth?.userInfo?.is_external_demo_mode
}
